import { Navigate, useLocation } from 'react-router-dom';

import { useSupabase } from '@/hooks/useSupabase';

interface Props {
  children: React.ReactNode;
}

/**
 * Guard de route: bloquea acceso si no hay sesión.
 *
 * Mientras carga la sesión muestra un placeholder (evita flash de
 * "not authenticated" en mount).
 */
export function RequireAuth({ children }: Props) {
  const { session, loading } = useSupabase();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="text-muted-foreground text-body-lg">Cargando sesión…</div>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
